export default __webpack_public_path__ + "static/media/flag-corsica.6058f465.svg";